var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { State } from "../../../hooks/useUseCase";
import { OrganizationType } from "./api/NameListApi";
import { ClosedUserSelectDialogPayload } from "./usecases/CloseUserSelectDialogUseCase";
import { OpenedUserSelectDialogPayload, FetchedOrganizationsPayload, } from "./usecases/OpenUserSelectDialogUseCase";
import { SelectedAllUsersPayload } from "./usecases/SelectAllUsersUseCase";
import { SelectedOrganizationPayload } from "./usecases/SelectOrganizationUseCase";
import { SelectedUserPayload } from "./usecases/SelectUserUseCase";
import { UnselectedAllUsersPayload } from "./usecases/UnselectAllUsersUseCase";
import { UnselectedUserPayload } from "./usecases/UnselectUserUseCase";
var UserSelectDialogState = /** @class */ (function (_super) {
    __extends(UserSelectDialogState, _super);
    function UserSelectDialogState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mode = 'multiple';
        _this.defaultUsers = [];
        _this.readonlyDefaultUsers = false;
        _this.organizations = [];
        _this.organizationUsersMap = {};
        _this.selectedUsersMap = {};
        return _this;
    }
    Object.defineProperty(UserSelectDialogState.prototype, "hasOrganizations", {
        get: function () {
            return this.organizations.length !== 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelectDialogState.prototype, "isSingleSelectMode", {
        get: function () {
            return this.mode === 'single';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelectDialogState.prototype, "isMultiSelectMode", {
        get: function () {
            return this.mode === 'multiple';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelectDialogState.prototype, "selectedOrganization", {
        get: function () {
            var _this = this;
            return this.organizations.find(function (organization) { return organization.id === _this.selectedOrganizationId; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelectDialogState.prototype, "selectedUsers", {
        get: function () {
            return Object.values(this.selectedUsersMap);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelectDialogState.prototype, "selectedUsersCount", {
        get: function () {
            return this.selectedUsers.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelectDialogState.prototype, "currentOrganizationUsers", {
        get: function () {
            var _this = this;
            if (!this.selectedOrganizationId)
                return [];
            return this.organizationUsersMap[this.selectedOrganizationId].map(function (user) {
                var defaultUser = _this.defaultUsers.find(function (_user) { return _user.id === user.id; });
                return {
                    user: user,
                    selected: !!_this.selectedUsersMap[user.id],
                    readonly: !!(defaultUser === null || defaultUser === void 0 ? void 0 : defaultUser.readonly),
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelectDialogState.prototype, "currentOrganizations", {
        /**
         * グループ単位で選択中の人数を計算する
         */
        get: function () {
            var organizationMap = Object.values(this.selectedUsersMap).reduce(function (result, user) {
                var organization = user.organization;
                result[organization.id] //
                    ? (result[organization.id].count += 1)
                    : (result[organization.id] = __assign(__assign({}, organization), { count: 1 }));
                return result;
            }, {});
            return Object.values(organizationMap);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelectDialogState.prototype, "hasLimit", {
        get: function () {
            return this.limit != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserSelectDialogState.prototype, "isExceedLimit", {
        get: function () {
            if (this.limit == null)
                return false;
            return this.limit < this.selectedUsersCount;
        },
        enumerable: false,
        configurable: true
    });
    UserSelectDialogState.prototype.reduce = function (payload) {
        var _a;
        var _this = this;
        var _b, _c;
        if (payload instanceof OpenedUserSelectDialogPayload) {
            this.mode = (_b = payload.mode) !== null && _b !== void 0 ? _b : this.mode;
            this.limit = payload.limit;
            this.defaultUsers = (_c = payload.defaultUsers) !== null && _c !== void 0 ? _c : this.defaultUsers;
            this.readonlyDefaultUsers = !!payload.readonlyDefaultUsers;
            this.defaultUsers.forEach(function (user) {
                _this.selectedUsersMap[user.id] = __assign(__assign({}, user), { organization: __assign(__assign({}, user.organization), { type: OrganizationType.Clazz }) });
            });
        }
        if (payload instanceof FetchedOrganizationsPayload) {
            this.organizations = payload.organizations;
        }
        if (payload instanceof SelectedOrganizationPayload) {
            this.selectedOrganizationId = payload.organizationId;
            this.organizationUsersMap[this.selectedOrganizationId] = payload.users;
        }
        if (payload instanceof SelectedUserPayload) {
            var user = payload.user;
            var selectedUser = __assign(__assign({}, user), { organization: this.selectedOrganization });
            if (this.isSingleSelectMode) {
                this.selectedUsersMap = (_a = {}, _a[user.id] = selectedUser, _a);
            }
            if (this.isMultiSelectMode) {
                this.selectedUsersMap[user.id] = selectedUser;
            }
        }
        if (payload instanceof UnselectedUserPayload) {
            delete this.selectedUsersMap[payload.user.id];
        }
        if (payload instanceof SelectedAllUsersPayload) {
            this.currentOrganizationUsers
                .filter(function (user) { return !user.readonly; })
                .forEach(function (_a) {
                var user = _a.user;
                var selectedUser = __assign(__assign({}, user), { organization: _this.selectedOrganization });
                _this.selectedUsersMap[user.id] = selectedUser;
            });
        }
        if (payload instanceof UnselectedAllUsersPayload) {
            this.currentOrganizationUsers
                .filter(function (user) { return !user.readonly; })
                .forEach(function (_a) {
                var user = _a.user;
                delete _this.selectedUsersMap[user.id];
            });
        }
        if (payload instanceof ClosedUserSelectDialogPayload) {
            this.selectedOrganizationId = undefined;
            this.selectedUsersMap = {};
        }
    };
    return UserSelectDialogState;
}(State));
export { UserSelectDialogState };
export var initialUserSelectDialogState = new UserSelectDialogState();
